export default __webpack_public_path__ + "static/media/bg.6afc3071.svg";